import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { NatureFollowerProject } from "../models";

@Injectable()
export class NatureFollowerProjectService {

    natureFollowerProjectsUrl = environment.dns + 'api/nature-follower-projects/';

    constructor(private http: HttpClient) { }

    getList(): Observable<NatureFollowerProject[]> {
        return this.http.get<NatureFollowerProject[]>(this.natureFollowerProjectsUrl + 'list');
    }

    getOne(id: number): Observable<NatureFollowerProject> {
        return this.http.get<NatureFollowerProject>(this.natureFollowerProjectsUrl + id);
    }

    add(typeProjectForm: NatureFollowerProject): Observable<NatureFollowerProject> {
        return this.http.post<NatureFollowerProject>(this.natureFollowerProjectsUrl, typeProjectForm);
    }

    update(typeProjectForm: NatureFollowerProject): Observable<NatureFollowerProject> {
        return this.http.put<NatureFollowerProject>(this.natureFollowerProjectsUrl, typeProjectForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.natureFollowerProjectsUrl + id);
    }

}